import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_511: DocMigration = {
  maxSchemaVersion: "0.0.511",
  description: "Migrate different doc entity types to use datumUsage",
  apply(json: any): any {
    const { facadeSweepStrata = {}, facadeSpanStrata = {}, levels = {}, edgeBehaviors = {} } = json;

    // migrate facade sweep strata to use datumUsage
    for (const sweepStratumId in facadeSweepStrata) {
      const sweepStratum = facadeSweepStrata[sweepStratumId];

      sweepStratum.datumUsage = {
        __usage: "WALL_VERTICAL",
        entityId: sweepStratum.datum,
        offset: sweepStratum.sweep.datumOffset,
      };

      delete sweepStratum.datum;
      delete sweepStratum.sweep.datumOffset;
    }

    // migrate facade span strata to use datumUsage
    for (const spanStratumId in facadeSpanStrata) {
      const spanStratum = facadeSpanStrata[spanStratumId];
      const { lowerDatum, upperDatum, startDatum, endDatum } = spanStratum;

      spanStratum.lowerDatumUsage = {
        __usage: "WALL_VERTICAL",
        entityId: lowerDatum,
      };

      spanStratum.upperDatumUsage = {
        __usage: "WALL_VERTICAL",
        entityId: upperDatum,
      };

      spanStratum.startDatumUsage = {
        __usage: "WALL_HORIZONTAL",
        entityId: startDatum,
      };

      spanStratum.endDatumUsage = {
        __usage: "WALL_HORIZONTAL",
        entityId: endDatum,
      };

      delete spanStratum.lowerDatum;
      delete spanStratum.upperDatum;
      delete spanStratum.startDatum;
      delete spanStratum.endDatum;
    }

    // migrate edge behaviors to use datumUsage
    for (const edgeBehaviorId in edgeBehaviors) {
      const edgeBehavior = edgeBehaviors[edgeBehaviorId];

      if (edgeBehavior.edgeBehaviorType !== "WALL_ASSEMBLY") {
        continue;
      }

      const { wallAssemblyOperator } = edgeBehavior;
      const { operationType } = wallAssemblyOperator;

      if (operationType !== "ADD" && operationType !== "REMOVE" && operationType !== "OVERRIDE") {
        continue;
      }

      const { layer } = wallAssemblyOperator;

      if (!layer) {
        continue;
      }

      const {
        lowerDatum,
        upperDatum,
        startDatum,
        endDatum,
        lowerDatumOffset,
        upperDatumOffset,
        startDatumOffset,
        endDatumOffset,
      } = layer;

      layer.lowerDatumUsage = {
        __usage: "WALL_VERTICAL",
        entityId: lowerDatum,
        offset: lowerDatumOffset,
      };

      layer.upperDatumUsage = {
        __usage: "WALL_VERTICAL",
        entityId: upperDatum,
        offset: upperDatumOffset,
      };

      layer.startDatumUsage = {
        __usage: "WALL_HORIZONTAL",
        entityId: startDatum,
        offset: startDatumOffset,
      };

      layer.endDatumUsage = {
        __usage: "WALL_HORIZONTAL",
        entityId: endDatum,
        offset: endDatumOffset,
      };

      delete layer.lowerDatum;
      delete layer.upperDatum;
      delete layer.startDatum;
      delete layer.endDatum;
      delete layer.lowerDatumOffset;
      delete layer.upperDatumOffset;
      delete layer.startDatumOffset;
      delete layer.endDatumOffset;
    }

    // migrate level placement datumUsage to the new format (remove datumId and add entityId)
    for (const levelId in levels) {
      const level = levels[levelId];

      if (level.placement.type !== "DATUM" || !level.placement.datumUsage) {
        continue;
      }

      level.placement.datumUsage = {
        ...level.placement.datumUsage,
        entityId: level.placement.datumUsage.datumId,
      };

      delete level.placement.datumUsage.datumId;
    }

    return json;
  },
};

export default migration_0_0_511;
